const transliterationMap = {
  zh: "ж",
  gj: "ѓ",
  lj: "љ",
  nj: "њ",
  dz: "ѕ",
  ch: "ч",
  sh: "ш",
  dj: "џ",
  a: "а",
  b: "б",
  v: "в",
  g: "г",
  d: "д",
  e: "е",
  z: "з",
  i: "и",
  j: "ј",
  k: "к",
  l: "л",
  m: "м",
  n: "н",
  o: "о",
  p: "п",
  r: "р",
  s: "с",
  t: "т",
  u: "у",
  f: "ф",
  h: "х",
  c: "ц",
};

const sortedLatinKeys = Object.keys(transliterationMap).sort(
  (a, b) => b.length - a.length
);

export const latinToCyrillic = (input = "") => {
  if (!input) {
    return "";
  }

  let result = input.toLowerCase();

  sortedLatinKeys.forEach((latin) => {
    const cyrillic = transliterationMap[latin];
    result = result.replaceAll(latin, cyrillic);
  });

  return result;
};
